import { callApiToServer } from "../callApi";

export async function exportUsers(authtoken) {
  try {
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Berear " + authtoken,
    };

    const endUrl = "v1/auth/admin/export-users";

    const responseData = await callApiToServer(null, header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
